var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFunnel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 35,
    viewBox: "0 0 33 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 32,
    height: 34,
    rx: 5.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 32,
    height: 34,
    rx: 5.5,
    stroke: "#DDDDDD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.3333C9 10.8666 9 10.6333 9.09082 10.455C9.17072 10.2982 9.29821 10.1707 9.45501 10.0908C9.63327 10 9.86662 10 10.3333 10H22.6667C23.1334 10 23.3668 10 23.545 10.0908C23.7018 10.1707 23.8293 10.2982 23.9092 10.455C24 10.6333 24 10.8666 24 11.3333V12.781C24 12.9849 24 13.0868 23.977 13.1827C23.9566 13.2677 23.9229 13.349 23.8772 13.4236C23.8257 13.5077 23.7536 13.5797 23.6095 13.7239L18.5572 18.7762C18.4131 18.9202 18.341 18.9923 18.2895 19.0764C18.2437 19.151 18.2101 19.2323 18.1897 19.3173C18.1667 19.4133 18.1667 19.5152 18.1667 19.7189V21.6667L14.8333 25V19.7189C14.8333 19.5152 14.8333 19.4133 14.8103 19.3173C14.7899 19.2323 14.7562 19.151 14.7105 19.0764C14.659 18.9923 14.5869 18.9202 14.4428 18.7762L9.39053 13.7239C9.2464 13.5797 9.17433 13.5077 9.1228 13.4236C9.07711 13.349 9.04344 13.2677 9.02303 13.1827C9 13.0868 9 12.9849 9 12.781V11.3333Z",
    stroke: "#332B6D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnel);
export default __webpack_public_path__ + "static/media/Funnel.24e167bd52010a5e60ca36cd555bdc69.svg";
export { ForwardRef as ReactComponent };